import React, { Suspense, useEffect, useRef } from "react";
import Styles from "./SyllabusComponent.module.css";
import PlainInput from "../Editor/PlainInput";
const TopicSelector = React.lazy(() =>
import("../../../components/molecules/TopicSelector/TopicSelector")
);
import { useRoot } from "../../../context/RootContext";
import TimeLogsModal from "../../timeLogs/TimeLogs";
import { getTaskCountAPI, getTimeLogs } from "../../../api/task-services";
import timeLogsDB from "../../../utils/TimeLogsDB";

// need to add loader for vin messages and section subject tree loading

const SyllabusComponent = (props) => {
  const { showTimeLogs, toggleTimeLogsDrawer, setLast7daysData } = useRoot();
  const fetchTimerRef = useRef(null);

  useEffect(() => {
    const fetchTimeLogs = async () => {
      try {
        let timeLogs = await getTimeLogs();
        // timeLogsDB.clearAllTimeLogs();
        if (timeLogs && timeLogs?.data?.length > 0) {
          timeLogs?.data.map((log) => {
            console.log("One");
            timeLogsDB.saveTimeLogs(log, true);
          });
        }
      } catch (error) {
        console.error("Error syncing time logs:", error);
      }
    };

    const getTaskCount = async () => {
      try {
        const taskCountResponse = await getTaskCountAPI();
        if (taskCountResponse.status) {
          setLast7daysData(taskCountResponse?.data?.["7days"]);
        }
      } catch (error) {
        console.log("ERROR", error);
      }
    };

    fetchTimeLogs();
    getTaskCount();
    //   fetchTimerRef.current = setInterval(fetchTimeLogs, 10 * 60 * 1000);

    //   // Cleanup function to clear interval when component unmounts
    //   return () => {
    //     if (fetchTimerRef.current) {
    //       clearInterval(fetchTimerRef.current);
    //       fetchTimerRef.current = null;
    //     }
    //   };
  }, []);

  const editor = () => {
    return <PlainInput isDisable={true} buttons={[]} />;
  };
  // console.log("PROPS", props);
  return (
    <div className={Styles.mainContainer}>
      <div className={Styles.syllabus}>
        <div className={Styles.syllabusSubComponent}>
          <Suspense fallback={<></>}>
            <TopicSelector
              openFull={true}
              unlockProps={props?.unlockProps}
              subject={props?.subject}
              subjectMasterUuid={props?.subjectMasterUuid}
              topic={props?.topicName}
              topicMasterUuid={props?.topicMasterUuid}
              subjectName={props?.subjectName}
              topicName={props?.topicName} />

          </Suspense>
        </div>
      </div>
      <div className={Styles.bottomContainer}>
        <div className={Styles.bottomEditor}>{editor()}</div>
        <div className={Styles.bottomBox} />
      </div>
      <TimeLogsModal isOpen={showTimeLogs} onClose={toggleTimeLogsDrawer} />
    </div>);

};

export default SyllabusComponent;